import ServiceLocator from "../global/service-locator";
import { initCoachInfo } from "./coach-info";
import ArrayHelper from "../lib/array-helper";
import {DEFER_INIT_EVENTS} from "../global/constants";

const sl = ServiceLocator.instance;
const $modal = document.getElementById('modal-coach-info');
let $showAllButton;
let $showAllLink;
let $root;
let $coachList;
let $coachCardItems;
let $coachCards;

export default function init() {
	$root = document.getElementById('coachesSection');

	if ($root) {
		$showAllButton = document.getElementById('coachesShowAllButton');
		$showAllLink = document.getElementById('coachesShowAllLink');
		$coachList = $root.querySelector('.coach-list');
		$coachCardItems = $coachList.querySelectorAll('.coach-list_item');
		$coachCards = $coachList.querySelectorAll('.coach-card');

		bootstrap();
	}
}

function bootstrap() {
	if ($coachCardItems.length > 12) {
		$coachList.innerHTML = '';
		const $randomizedCoachCards = ArrayHelper.shuffle(Array.from($coachCardItems));
		$randomizedCoachCards.sort((a, b) => {
			const $aCompany = a.querySelector('.coach-card_company');
			const $bCompany = b.querySelector('.coach-card_company');

			return $aCompany && $bCompany ? 0 : $aCompany ? -1 : 1;
		});

		$randomizedCoachCards.forEach(($card, index) => {
			$coachList.appendChild($card);

			if ($coachCardItems.length > 12 && index > 5) {
				$card.style.display = 'none';
			}
		});
	}

	if ($showAllLink) {
		$showAllLink.href = location.origin + '/coaches';
	}

	const events = DEFER_INIT_EVENTS;
	const handler = e => {
		e.stopPropagation();

		addEventListeners();

		events.forEach(event => {
			window.removeEventListener(event, handler);
		});
	};


	events.forEach(event => {
		window.addEventListener(event, handler);
	});
}

const addEventListeners = () => {
	let isShown = false;

	addShowCoachModalListener();

	if ($showAllButton) {
		$showAllButton.addEventListener('click', () => {
			$coachCardItems.forEach(($card) => {
				if (isShown) {
					$card.classList.remove('-active');
				} else {
					$card.classList.add('-active');
				}
			});

			if (isShown) {
				$showAllButton.classList.remove('-shown');
			} else {
				$showAllButton.classList.add('-shown');
			}

			isShown = !isShown;
		});
	}
}

function addShowCoachModalListener() {
	if (!$modal) {
		throw new Error('Coaches Slider: Coach Info Model does not exist.');
	}
	try {
		sl.modalService.register('coach-info', Array.from($coachCards), {
			beforeOpen: ($trigger) => {
				initCoachInfo($trigger.closest('.coach-card'));
			}
		});
	} catch (err) {
		console.error('Coach Slider:', err);
	}
}

